export default __webpack_public_path__ + "static/media/2394.ca1da0ab.jpg";